import { Spinner } from 'construct-ui';
import moment from 'moment';
import SingleSelectComponent from '../../components/single-select/single-select.component';
import { formats } from '../../config/constants';
import SEAOGoodMovementModel from '../../models/retail-asset-management/seao-goods-movement.model';
import { checkSEAOUserMovementWarehouseMapAuthorization } from '../../models/retail-asset-management/seao-posm-authorization.model';
import { getSEAOHierachyTreeByLevel, getSEAOHierachyTreeByParentCode } from '../../models/retail-asset-management/seao-posm-master.model';
import ViewBase from '../view-base.view';
import CreateSEAOPOSMGoodsReceiveDialog from './create-seao-goods-receive.dialog';
import DisplayAllGoodsReceive from './display-all-goods-receive.view';
import SEAOPOSMGoodsMovementFooter from './seao-posm-goods-movement-footer';
import WarehouseStorageSelectCreateComponent from './warehouse-storage-select-create.component';

/**
 *
 *s
 * @author
 */

export default function SEAOPOSMGoodsMovement() {
  ViewBase.call(this);
  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1
  }
  const DEFAULT_FILTERS = {
    DateFrom: moment().subtract(1, 'M').startOf('M').format(formats.apiDateFormat),
    DateTo: moment().format(formats.apiDateFormat),
    MovementBy: "",
    ChannelCd: "",
    VendorID: "",
  };

  const CATEGORY_ORDER = {
    MAIN: 0,
    GOODS_TYPE: 1,
    DIVISION: 2,
    MODEL: 3,
    BASIC_MODEL: 4,
  };

  let listGoodMovement = [];
  let totalListGoodMovement = 0;
  let movementDetail = structuredClone({
    main: SEAOGoodMovementModel?.movementDetail?.main,
    goodsType: SEAOGoodMovementModel?.movementDetail?.goodsType,
    division: SEAOGoodMovementModel?.movementDetail?.division,
    model: SEAOGoodMovementModel?.movementDetail?.model,
    basicModel: SEAOGoodMovementModel?.movementDetail?.basicModel,
  });
  let filterObj = structuredClone(DEFAULT_FILTERS);
  let paginationObj = structuredClone(DEFAULT_PAGINATION);
  let currentFilter = {};
  let MOVEMENT_OPTIONS = {
    main: SEAOGoodMovementModel.main,
    goodsType: SEAOGoodMovementModel.goodsType,
    division: SEAOGoodMovementModel.division,
    model: SEAOGoodMovementModel.model,
    basicModel: SEAOGoodMovementModel.basicModel,
  };

  let isHierachyLoading = false;
  let isCreateMovementDialogOpen = false;
  let currentInputGoodTypeOrder = 0;
  const setPaginationObj = (paginationObjPatch) => {
    paginationObj = { ...paginationObj, ...paginationObjPatch };
    currentFilter = { ...currentFilter, ...paginationObj };
  }

  let movementControlCode = ''

  const setFilterObj = (filterObjPatch) => {
    filterObj = { ...filterObj, ...filterObjPatch }
  }
  const getFilterObj = () => {
    return filterObj;
  }
  const resetMovementDetailGoodtype = (inputGoodTypeOrder) => {
    let currentIndex = 0;
    for (const prop in movementDetail) {
      if (currentIndex <= CATEGORY_ORDER.BASIC_MODEL) {
        if (currentIndex > inputGoodTypeOrder) {
          movementDetail[prop] = { id: null, code: null, name: null };
        }
      }
      currentIndex++;
    }
    SEAOGoodMovementModel.setMovementDetail(movementDetail);
  };
  const onDownLoadGoodMovement = () => {
    return SEAOGoodMovementModel.downloadGoodMovement(currentFilter)
  }
  const setCurrentFilter = () => {
    currentFilter = {
      ...filterObj,
      MainId: SEAOGoodMovementModel.movementDetail?.main?.id,
      GoodsTypeId: SEAOGoodMovementModel.movementDetail?.goodsType?.id,
      DivisionId: SEAOGoodMovementModel.movementDetail?.division?.id,
      ModelId: SEAOGoodMovementModel.movementDetail?.model?.id,
      BasicModelId: SEAOGoodMovementModel.movementDetail?.basicModel?.id,
      MovementTypeCode: SEAOGoodMovementModel.movementDetail?.movementType?.code,
      WarehouseCode: SEAOGoodMovementModel.movementDetail?.warehouse?.code,
      StorageLocationCode: SEAOGoodMovementModel.movementDetail?.storageLocation?.code
    }
    filterObj = currentFilter;
  }
  const onSearchForGoodMovementList = (refreshPagination = false) => {
    this.showLoading();
    if (refreshPagination) {
      setPaginationObj({ pageIndex: 1, pageSize: 10 })
    }
    SEAOGoodMovementModel.getListGoodMovement(currentFilter).then((data) => {
      totalListGoodMovement = data.total;
      listGoodMovement = data.data;
    }).catch((err) => {
      this.handleError(err);
    })
      .finally(() => {
        this.hideLoading()
      })
  }

  const onSelect = (s, categoryName, categoryOrderName, categoryOrderChildName, categoryChildName) => {
    const oldCode = movementDetail[categoryName]?.id
    movementDetail[categoryName] = s;
    if (s.id) {
      if (s.id != oldCode) {

        isHierachyLoading = true;
        currentInputGoodTypeOrder = CATEGORY_ORDER[categoryOrderChildName];
        resetMovementDetailGoodtype(
          currentInputGoodTypeOrder
        );
        getSEAOHierachyTreeByParentCode(s.id)
          .then((data) => {
            SEAOGoodMovementModel.setHierachyOptions(
              categoryChildName,
              data
            );
            MOVEMENT_OPTIONS[categoryChildName] =
              SEAOGoodMovementModel.createHierachyOptions(
                data
              );
            isHierachyLoading = false;
          })
          .catch((err) => {
            isHierachyLoading = false;
            handleError(err);
          });
        movementDetail[categoryChildName] = { id: null, code: null, name: null };
      }
    } else {
      currentInputGoodTypeOrder = CATEGORY_ORDER[categoryOrderName];
      movementDetail[categoryName] = {
        id: null,
        name: null,
        code: null,
      };

      resetMovementDetailGoodtype(
        CATEGORY_ORDER[categoryOrderName]
      );
    }
    SEAOGoodMovementModel.setMovementDetail(movementDetail);
  }
  const onSelectBasicModel = (s) => {
    const oldCode = movementDetail.basicModel.id;
    movementDetail.basicModel = s;
    SEAOGoodMovementModel.setMovementDetail(movementDetail);
    if (s.id) {
      if (s.id != oldCode) {
        currentInputGoodTypeOrder =
          CATEGORY_ORDER.BASIC_MODEL;
      }
    } else {
      currentInputGoodTypeOrder =
        CATEGORY_ORDER.BASIC_MODEL;
      movementDetail.basicModel = {
        id: null,
        name: null,
        code: null,
      };
    }
  }
  const handleError = this.handleError;
  const getFirstLevelOptions = () => {
    getSEAOHierachyTreeByLevel(1, 1)
      .then((data) => {
        MOVEMENT_OPTIONS.main =
          SEAOGoodMovementModel.createHierachyOptions(data);
        SEAOGoodMovementModel.setHierachyOptions('main', data);
        isHierachyLoading = false;
      })
      .catch((err) => {
        isHierachyLoading = false;
        handleError(err);
      });
  }
  const getChildOptions = (parentCode, currentProp) => {
    getSEAOHierachyTreeByParentCode(parentCode)
      .then((data) => {
        MOVEMENT_OPTIONS[currentProp] = SEAOGoodMovementModel.createHierachyOptions(data);
        SEAOGoodMovementModel[currentProp] = SEAOGoodMovementModel.createHierachyOptions(data);
        isHierachyLoading = false;

      })
      .catch((err) => {
        isHierachyLoading = false;
        handleError(err);
      });
  }
  const getCurrentParent = () => {
    let currentIndex = 0;
    let parentCode = '';
    let currentProp = '';
    for (const prop in movementDetail) {
      if (currentIndex <= CATEGORY_ORDER.BASIC_MODEL) {
        if (!movementDetail[prop]?.id) {
          currentInputGoodTypeOrder = currentIndex;
          currentProp = prop;
          break;
        } else {
          parentCode = movementDetail[prop]?.id;
        }
      }
      currentIndex++;
    }
    return {
      currentIndex,
      parentCode,
      currentProp
    }
  }
  let hierachyLabels = SEAOGoodMovementModel.SEAOHierachyLabel;

  let clearMovementTypeFunction = () => {
    SEAOGoodMovementModel.setMovementDetail({
      warehouse: { code: null, name: null },
      storageLocation: { code: null, name: null },
    })
  }

  const handleClear = () => {
    onSelect({ id: null, code: null, name: null }, 'main', 'MAIN', 'GOODS_TYPE', 'goodsType')
    clearMovementTypeFunction()
    filterObj = structuredClone(DEFAULT_FILTERS);
    setCurrentFilter();
  }
  let previousWarehouseCode = '';
  let userMovementWarehouseMapAuthority = false;
  const getCheckUserMovementWarehouseMapAuthorization = (movementType, warehouseID) => {
    previousWarehouseCode = warehouseID;
    checkSEAOUserMovementWarehouseMapAuthorization({ movementType, warehouseID })
      .then((result) => {
        userMovementWarehouseMapAuthority = result === 'Y';
      })
      .catch((error) => {
        this.handleError(error)
      })
  }
  return {
    oninit: function () {
      isHierachyLoading = true;
      const currentParentObj = getCurrentParent();
      currentInputGoodTypeOrder = currentParentObj.currentIndex
      getFirstLevelOptions();
      if (currentParentObj.parentCode) {
        getChildOptions(currentParentObj.parentCode, currentParentObj.currentProp);
      }
      setCurrentFilter();
      setPaginationObj();
      onSearchForGoodMovementList();
    },
    //Check Posm User Movement Warehouse Map Authorization
    onupdate: () => {
      if (SEAOGoodMovementModel.movementDetail.basicModel.id && SEAOGoodMovementModel.movementDetail.storageLocation.code) {
        if (previousWarehouseCode != SEAOGoodMovementModel.movementDetail.warehouse.code) {
          getCheckUserMovementWarehouseMapAuthorization('GR', SEAOGoodMovementModel.movementDetail.warehouse.code)
        }
      } else userMovementWarehouseMapAuthority = false;
    },
    onremove: function () {
      if (!SEAOGoodMovementModel.isGoingtoHierachy) {
        SEAOGoodMovementModel.resetMovementDetail();
      }
    },

    view: () => {
      return [
        /* SEARCH */
        isHierachyLoading &&
        m(Spinner, { fill: true, background: true, active: true }),
        m('.card.mb-3',
          m('.card-body',
            m('.position-relative',
              m('.row.row-cols-5.g-2.mb-2',
                m('.col.position-relative', [
                  m('label.form-label', this.getText(hierachyLabels[0][1], hierachyLabels[0][0])),
                  m('.input-group',
                    m(SingleSelectComponent, {
                      popoverAttrs: { class: 'posm-filters' },
                      items: MOVEMENT_OPTIONS.main,
                      selectedItem: movementDetail.main,
                      checkmark: true,
                      filterable: true,
                      onSelect: (s) => {
                        onSelect(s, 'main', 'MAIN', 'GOODS_TYPE', 'goodsType')
                      },
                    }),
                  ),
                ]),
                m('.col.position-relative', currentInputGoodTypeOrder >= CATEGORY_ORDER.GOODS_TYPE && [
                  m('label.form-label', this.getText(hierachyLabels[1][1], hierachyLabels[1][0])),
                  m('.input-group',
                    m(SingleSelectComponent, {
                      activeIndex: (SEAOGoodMovementModel.goodsType.findIndex((item) => { return item.id == movementDetail.goodsType.id }) + 1) || 0,
                      popoverAttrs: { class: 'posm-filters' },
                      allowEmpty: MOVEMENT_OPTIONS.goodsType.length != 0,
                      items: MOVEMENT_OPTIONS.goodsType,
                      selectedItem: movementDetail.goodsType,
                      checkmark: true,
                      filterable: true,

                      onSelect: (s) => {
                        onSelect(s, 'goodsType', 'GOODS_TYPE', 'DIVISION', 'division')
                      },
                    }),
                    !movementDetail.goodsType.id &&
                    m('button.btn.btn-sm.btn-primary',
                      {
                        onclick: () => {
                          SEAOGoodMovementModel.setMovementDetail(
                            movementDetail
                          );
                          SEAOGoodMovementModel.isFromPOSMGoodMovement = true;
                          m.route.set('/seao/posm-global-hierarchy');
                          SEAOGoodMovementModel.isGoingtoHierachy = true;
                        },
                      },
                      [m('i.bi.bi-plus-lg.me-0')]
                    )

                  )
                ]),


                m('.col.position-relative', currentInputGoodTypeOrder >= CATEGORY_ORDER.DIVISION && [
                  m('label.form-label', this.getText(hierachyLabels[2][1], hierachyLabels[2][0])),
                  m('.input-group',
                    m(SingleSelectComponent, {
                      activeIndex: (SEAOGoodMovementModel.division.findIndex((item) => { return item.id == movementDetail.division.id }) + 1) || 0,
                      popoverAttrs: { class: 'posm-filters' },
                      allowEmpty: MOVEMENT_OPTIONS.division.length != 0,
                      items: MOVEMENT_OPTIONS.division,
                      selectedItem: movementDetail.division,
                      checkmark: true,
                      filterable: true,
                      onSelect: (s) => {
                        onSelect(s, 'division', 'DIVISION', 'MODEL', 'model')
                      },
                    }),
                    !movementDetail.division.id &&
                    m('button.btn.btn-sm.btn-primary',
                      {
                        onclick: () => {
                          SEAOGoodMovementModel.setMovementDetail(
                            movementDetail
                          );
                          SEAOGoodMovementModel.isFromPOSMGoodMovement = true;
                          m.route.set('/seao/posm-global-hierarchy');
                          SEAOGoodMovementModel.isGoingtoHierachy = true;
                        },
                      },
                      [m('i.bi.bi-plus-lg.me-0')]
                    )
                  ),
                ]),

                m('.col.position-relative', currentInputGoodTypeOrder >= CATEGORY_ORDER.MODEL && [
                  m('label.form-label', this.getText(hierachyLabels[3][1], hierachyLabels[3][0])),
                  m('.input-group',
                    m(SingleSelectComponent, {
                      activeIndex: (SEAOGoodMovementModel.model.findIndex((item) => { return item.id == movementDetail.model.id }) + 1) || 0,
                      popoverAttrs: { class: 'posm-filters' },
                      allowEmpty: MOVEMENT_OPTIONS.model.length != 0,
                      items: MOVEMENT_OPTIONS.model,
                      selectedItem: movementDetail.model,
                      checkmark: true,
                      filterable: true,
                      onSelect: (s) => {
                        onSelect(s, 'model', 'MODEL', 'BASIC_MODEL', 'basicModel')
                      },
                    }),
                    !movementDetail.model.id &&
                    m('button.btn.btn-sm.btn-primary',
                      {
                        onclick: () => {
                          SEAOGoodMovementModel.setMovementDetail(
                            movementDetail
                          );
                          SEAOGoodMovementModel.isFromPOSMGoodMovement = true;
                          m.route.set('/seao/posm-global-hierarchy');
                          SEAOGoodMovementModel.isGoingtoHierachy = true;
                        },
                      },
                      [m('i.bi.bi-plus-lg.me-0')]
                    )
                  ),
                ]),

                m('.col.position-relative', currentInputGoodTypeOrder >= CATEGORY_ORDER.BASIC_MODEL && [
                  m('label.form-label', this.getText(hierachyLabels[4][1], hierachyLabels[4][0])),
                  m('.input-group',
                    m(SingleSelectComponent, {
                      activeIndex: (SEAOGoodMovementModel.basicModel.findIndex((item) => { return item.id == movementDetail.basicModel.id }) + 1) || 0,
                      popoverAttrs: { class: 'posm-filters' },
                      allowEmpty: MOVEMENT_OPTIONS.basicModel.length != 0,
                      items: MOVEMENT_OPTIONS.basicModel,
                      selectedItem: movementDetail.basicModel,
                      checkmark: true,
                      filterable: true,
                      onSelect: (s) => {
                        onSelectBasicModel(s);
                      },
                    }),
                    !movementDetail.basicModel.id &&
                    m('button.btn.btn-sm.btn-primary',
                      {
                        onclick: () => {
                          SEAOGoodMovementModel.setMovementDetail(
                            movementDetail
                          );
                          SEAOGoodMovementModel.isFromPOSMGoodMovement = true;
                          m.route.set('/seao/posm-global-hierarchy');
                          SEAOGoodMovementModel.isGoingtoHierachy = true;
                        },
                      },
                      [m('i.bi.bi-plus-lg.me-0')]
                    )
                  ),
                ])
              ),
              m(WarehouseStorageSelectCreateComponent),
              (SEAOGoodMovementModel.movementDetail.basicModel?.id && SEAOGoodMovementModel.movementDetail.storageLocation?.code) &&
              userMovementWarehouseMapAuthority &&
              m('button.btn.btn-primary.position-absolute.bottom-0.end-0',
                {
                  onclick: () => {
                    isCreateMovementDialogOpen = true;
                  },
                },
                m('i.bi.bi-plus-lg.me-0'),
                this.getText('LT00001296', 'Goods Receive')
              )
            ),
            m('hr'),
            m(SEAOPOSMGoodsMovementFooter, { filterObj, onSearchForGoodMovementList, setFilterObj, setCurrentFilter, handleClear }),
          )),
        m(DisplayAllGoodsReceive, {
          listGoodMovement,
          totalItems: totalListGoodMovement,
          onSearchForGoodMovementList,
          onDownLoadGoodMovement,
          setPaginationObj,
          setFilterObj,
          getFilterObj,
          paginationObj,
          onOpenMovementDetail: (code) => {
            isCreateMovementDialogOpen = true;
            movementControlCode = code;
          }
        }),

        /* CREATE GOODS MOVEMENT DIALOG */
        isCreateMovementDialogOpen &&
        m(CreateSEAOPOSMGoodsReceiveDialog, {
          isOpen: isCreateMovementDialogOpen,
          onClose: (refresh = false) => {
            isCreateMovementDialogOpen = false;
            movementControlCode = '';
            if (refresh === true)
              onSearchForGoodMovementList(true);

          },
          movementControlCode
        }),

        this.getBaseViews(),
      ];
    },
  };
}
